import axios from "axios";

const API_BASE = "http://localhost:3001/api/v1/tutorial";

export interface Track {
  id: number;
  name: string;
  slug: string;
  description: string;
  icon: string;
  color: string;
  sort_order: number;
}

export interface Course {
  id: number;
  track_id: number;
  name: string;
  slug: string;
  description: string;
  prerequisite: string;
  sort_order: number;
}

export interface Chapter {
  id: number;
  course_id: number;
  name: string;
  slug: string;
  sort_order: number;
}

export interface Article {
  id: number;
  chapter_id: number;
  title: string;
  slug: string;
  content: string;
  code_examples: any[];
  sort_order: number;
}

export interface TrackTree {
  track: Track;
  courses: Array<
    Course & { chapters: Array<Chapter & { articles: Article[] }> }
  >;
}

export interface TutorialState {
  tracks: Track[];
  tree: TrackTree | null;
  currentArticle:
    | (Article & {
        prev_article: { slug: string; title: string } | null;
        next_article: { slug: string; title: string } | null;
      })
    | null;
  loading: boolean;
}

export default {
  namespaced: true,
  state: (): TutorialState => ({
    tracks: [],
    tree: null,
    currentArticle: null,
    loading: false,
  }),
  mutations: {
    SET_TRACKS(state: TutorialState, tracks: Track[]) {
      state.tracks = tracks;
    },
    SET_TREE(state: TutorialState, tree: TrackTree) {
      state.tree = tree;
    },
    SET_ARTICLE(
      state: TutorialState,
      article: TutorialState["currentArticle"]
    ) {
      state.currentArticle = article;
    },
    SET_LOADING(state: TutorialState, loading: boolean) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTracks({ commit }: any) {
      commit("SET_LOADING", true);
      try {
        const res = await axios.get(`${API_BASE}/tracks`);
        if (res.data.code === 200) {
          commit("SET_TRACKS", res.data.data);
        }
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async fetchTree({ commit }: any, trackSlug: string) {
      commit("SET_LOADING", true);
      try {
        const res = await axios.get(`${API_BASE}/tree/${trackSlug}`);
        if (res.data.code === 200) {
          commit("SET_TREE", res.data.data);
        }
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async fetchArticle({ commit }: any, articleSlug: string) {
      commit("SET_LOADING", true);
      try {
        const res = await axios.get(`${API_BASE}/articles/${articleSlug}`);
        if (res.data.code === 200) {
          commit("SET_ARTICLE", res.data.data);
        }
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
};
